import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SEO from '../components/SEO';

const { FiArrowLeft, FiHeart } = FiIcons;

const WarmWelcome = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Warm Welcome | R. Venue Apartelle Lucban",
    "description": "Experience genuine Filipino hospitality at R. Venue Apartelle. Enjoy a peaceful retreat in the heart of Lucban with boutique comforts and attentive care.",
    "url": "https://rvenueapartelle.lucban.ph/warm-welcome"
  };

  return (
    <div className="w-full">
      <SEO 
        title="Warm Welcome"
        description="Experience genuine Filipino hospitality at R. Venue Apartelle. Enjoy a peaceful retreat in the heart of Lucban with boutique comforts and attentive care."
        canonical="/warm-welcome"
        ogImage="https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/images/aW1hZ2UvcG5n/2f8fff516883061ad7479fe1f24c4fa4.png"
        schema={pageSchema}
      />
      <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden pt-[100px]">
        <div className="absolute inset-0 z-0">
          <img src="https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/images/aW1hZ2UvcG5n/2f8fff516883061ad7479fe1f24c4fa4.png" alt="Warm Home Hospitality" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-brand-olive/70" />
        </div>
        <div className="relative z-10 text-center px-6 mt-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-16 h-16 bg-brand-cream/10 rounded-full flex items-center justify-center mx-auto mb-6 backdrop-blur-sm border border-white/20">
            <SafeIcon icon={FiHeart} className="text-brand-cream text-2xl" />
          </motion.div>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-script text-3xl text-brand-cream mb-4">Filipino Hospitality</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="font-serif text-4xl md:text-6xl uppercase tracking-[0.2em] text-white">Warm Welcome</motion.h1>
        </div>
      </section>

      <section className="py-24 bg-brand-cream">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <h2 className="font-serif text-3xl uppercase tracking-widest text-brand-olive mb-8">Your Home Away From Home</h2>
          <div className="w-20 h-[1px] bg-brand-olive/30 mx-auto mb-10" />
          <div className="space-y-6 text-brand-olive/80 text-lg leading-relaxed font-light text-left md:text-center">
            <p>In Lucban, hospitality isn't just a practice—it's a way of life. The locals are known for their genuine smiles, friendly greetings, and a deep-rooted culture of making every visitor feel like family.</p>
            <p>At R. Venue Apartelle, we have woven this very essence into the fabric of our service.</p>
          </div>
          <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-6">
            <Link to="/rates" className="btn-primary">Check Availability</Link>
            <Link to="/" className="inline-flex items-center gap-2 text-brand-olive font-bold uppercase tracking-widest text-xs hover:text-brand-dark transition-colors"><SafeIcon icon={FiArrowLeft} /> Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WarmWelcome;